import { Modal } from "@visiblethread/react-components";
import StageRow from "components/PipelineFunnel/StageRow";
import { modalTypes } from "constants/types";
import { arrayOf, number, shape, string } from "prop-types";
import React, { useMemo } from "react";
import { useDispatch } from "react-redux";
import { hideModal } from "slices/app/actions/modals";

import styles from "./PipelineFunnelModal.module.scss";

const MODAL_TITLE = "Pipeline Funnel";

const PipelineFunnelModal = ({ data }) => {
  const dispatch = useDispatch();
  const { stages = [], currency } = data;

  const maxCount = useMemo(
    () => Math.max(...stages.map((s) => s.opportunityCount), 1),
    [stages]
  );

  const onDismiss = () => {
    dispatch(hideModal(modalTypes.PIPELINE_FUNNEL));
  };

  const stagesLabel =
    stages.length === 1 ? "1 stage" : `${stages.length} stages`;

  return (
    <Modal
      backdrop
      centered
      className={`fade-in ${styles.modal}`}
      onDismiss={onDismiss}
      show
      size="lg"
    >
      <Modal.Header>{MODAL_TITLE}</Modal.Header>
      <Modal.Body>
        <div className={styles.pipelineFunnelModal}>
          <p className={styles.pipelineFunnelModal__subHeader}>{stagesLabel}</p>
          <div className={styles.pipelineFunnelModal__rows}>
            {stages.map((s) => (
              <StageRow
                key={s.stageId}
                color={s.color}
                currency={currency}
                maxCount={maxCount}
                opportunityCount={s.opportunityCount}
                opportunityNames={s.opportunityNames}
                remainingCount={s.remainingCount ?? 0}
                stageName={s.stageName}
                value={s.value}
              />
            ))}
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

PipelineFunnelModal.propTypes = {
  data: shape({
    currency: string,
    stages: arrayOf(
      shape({
        stageId: number.isRequired,
        stageName: string.isRequired,
        color: string.isRequired,
        opportunityCount: number.isRequired,
        value: number.isRequired,
        opportunityNames: arrayOf(string),
        remainingCount: number,
      })
    ).isRequired,
  }).isRequired,
};

export default PipelineFunnelModal;
